module.exports = __webpack_public_path__ + "static/preview-image-d74e61458f20f5108cc5dab376952d31.png";